exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".RTableCell {\n  height: 100%;\n  color: #022917;\n  font-size: 16px;\n  font-weight: 400;\n  border-bottom: 1px solid transparent;\n  padding: 15px 30px 14px; }\n  .RTableCell.left {\n    text-align: left; }\n  .RTableCell.center {\n    text-align: center; }\n  .RTableCell.right {\n    text-align: right; }\n  .RTableCell.light {\n    font-weight: 200; }\n  .RTableCell.normal {\n    font-weight: 400; }\n  .RTableCell.bold {\n    font-weight: 700; }\n  .RTableCell.bg-green {\n    background-color: #A4EBD9; }\n  .RTableCell.bottom-border {\n    border-color: #bbb; }\n  .RTableCell.firstColumn {\n    padding-left: 15px; }\n  .RTableCell .Button {\n    font-size: 0.8rem;\n    max-height: 28px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/RTable/RTableCell/RTableCell.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/RTable/RTableCell/RTableCell.css
// module chunks = 0